export default __webpack_public_path__ + "static/media/ico-doc-db-score-low.f1a6576c.svg";